<template>
  <div class="cWrapper">
    <el-card>
      <el-row class="title-biaoti">档位配置</el-row>
      <el-row class="search">
        <el-input
          v-model="queryLiveInfo.taskLevel"
          placeholder="任务档位"
          clearable
        />
        <el-select v-model="queryLiveInfo.valid" placeholder="是否有效">
          <!-- <el-option label="全部" value="" /> -->
          <el-option label="有效" :value="1" />
          <el-option label="无效" :value="0" />
        </el-select>
        <el-button type="primary" @click="query" :loading="login">
          查询
        </el-button>
        <el-button type="primary" @click="operate(1)"> 新增 </el-button>
      </el-row>
      <el-row>
        <el-table height="65vh" :data="dataList" v-loading="login">
          <el-table-column prop="taskLevel" label="任务档位" align="center" />
          <el-table-column prop="levelName" label="档位名字" align="center" />
          <el-table-column prop="levelDesc" label="档位描述" align="center" />
          <el-table-column prop="valid" label="是否有效" align="center">
            <!-- 是否可用valid，0/1 -->
            <template slot-scope="scope">
              <el-tag v-if="scope.row.valid == 0" type="danger">无效</el-tag>
              <el-tag v-else type="success">有效</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="countryList" label="国家" align="center">
            <template slot-scope="scope">
              {{
                scope.row.countryList.toString() == ''
                  ? 'all'
                  : scope.row.countryList.toString()
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="minPerformance"
            label="最低业绩"
            align="center"
          />
          <el-table-column prop="ctimeStr" label="创建时间" align="center" />
          <el-table-column prop="mtimeStr" label="修改时间" align="center" />
          <el-table-column prop="operator" label="操作人" align="center" />

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="btns">
                <el-button
                  type="primary"
                  size="mini"
                  @click="operate(2, scope.row)"
                >
                  编辑
                </el-button>
                <el-button
                  type="primary"
                  size="mini"
                  @click="goToNode(scope.row)"
                >
                  对应节点
                </el-button>
              </div>
            </template>
          </el-table-column></el-table
        >
      </el-row>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="paginationInfo.page"
        :page-size="paginationInfo.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="paginationInfo.total"
      />
    </el-card>

    <el-dialog
      :title="isAdd ? '新增' : '编辑'"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <el-form :model="form" label-width="100px">
        <el-form-item>
          <el-switch
            v-model="isCountry"
            active-text="排除国家选择"
            inactive-text="国家选择"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="国家" prop="countryList">
          <el-select
            v-model="countryCode"
            @change="selectCountry"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in countryList"
              :key="item.countryCode"
              :label="item.country"
              :value="item.countryCode"
            >
            </el-option>
          </el-select>
          <div class="countryList">
            <div class="item" v-for="(item, index) in form.countryList">
              {{ item == '' ? 'all' : item }}
              <i
                class="close el-icon-circle-close"
                @click="deleteCountry(index)"
              ></i>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="任务档位" prop="taskLevel">
          <el-input v-model="form.taskLevel" />
        </el-form-item>
        <el-form-item label="最低业绩" prop="minPerformance">
          <el-input v-model="form.minPerformance" />
        </el-form-item>
        <el-form-item label="档位名字" prop="levelName">
          <el-input v-model="form.levelName" />
        </el-form-item>
        <el-form-item label="是否有效" prop="valid">
          <el-select v-model="form.valid" placeholder="是否有效">
            <el-option label="有效" value="1" />
            <el-option label="无效" value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="档位描述" prop="levelDesc">
          <el-input v-model="form.levelDesc" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
    <open_node_management ref="open_node_management" />
  </div>
</template>
<script>
import { UTCTimeToDate } from '@/utils/common'
import open_node_management from './open_node_management.vue'
export default {
  components: {
    open_node_management,
  },
  data() {
    return {
      dataList: [],
      isCountry: false,
      login: false,
      countryCode: '',
      countryList: [],
      queryLiveInfo: {
        taskLevel: '',
        valid: 1,
      },
      paginationInfo: {
        total: 0,
        pageSize: 30,
        page: 1,
      },
      isAdd: false,
      dialogVisible: false,
      form: {
        taskLevel: '',
        minPerformance: '',
        levelName: '',
        valid: '',
        levelDesc: '',
        countryList: [],
      },
    }
  },
  async created() {
    this.query()
    this.getCountryCode()
  },
  methods: {
    selectCountry(value) {
      console.log(this.form)
      if (!this.form.countryList) {
        this.form.countryList = []
      }
      if (
        value != 'all' &&
        value != 'total' &&
        this.form.countryList.findIndex((item) => item == value) == -1
      ) {
        if (this.form.countryList[0] == '') {
          return this.$message.error('已选择all或total,不能添加国家')
        } else {
          this.form.countryList.push(value)
        }
      } else {
        if (this.form.countryList.length > 0) {
          return this.$message.error('已选择国家，不能添加all或total')
        } else {
          this.form.countryList.push('')
        }
      }
    },
    deleteCountry(index) {
      this.form.countryList.splice(index, 1)
    },
    async query(page) {
      if (page) this.paginationInfo.page = 1
      this.login = true
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_live_query +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        {
          page: this.paginationInfo.page,
          pageSize: this.paginationInfo.pageSize,
          taskLevel: this.queryLiveInfo.taskLevel,
          valid: this.queryLiveInfo.valid,
        }
      )
      this.login = false
      if (res.code != 0) return this.$message(res.msg)
      this.dataList = res.data.resultList
      this.paginationInfo.total = res.data.totalPages
      this.dataList.map((item) => {
        if (item.ctime !== 0)
          item.ctimeStr = UTCTimeToDate(item.ctime, 'yyyy-MM-dd HH:mm:ss')
        if (item.mtime !== 0)
          item.mtimeStr = UTCTimeToDate(item.mtime, 'yyyy-MM-dd HH:mm:ss')
      })
    },
    goToNode(item) {
      this.$refs.open_node_management.queryNodeInfo.taskLevel = item.taskLevel
      this.$refs.open_node_management.query(true)
      this.$nextTick(() => {
        this.$refs.open_node_management.$el.scrollIntoView({
          behavior: 'smooth',
        })
      })
    },
    operate(type, row) {
      this.isAdd = type == 1
      if (type == 2) {
        // 将valid转换为字符串
        row.valid = row.valid + ''
        this.form = JSON.parse(JSON.stringify(row))
      }
      this.dialogVisible = true
    },
    // 获取国家选项
    async getCountryCode() {
      const { data: res } = await this.$axios({
        method: 'POST',
        url:
          this.$store.getters.path.normal_country +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
      })

      if (res.code != 0) {
        return this.$message.error(res.msg)
      } else {
        this.countryList = res.data.countryList
      }
    },
    submit() {
      if (this.isCountry && this.form.countryList[0]) {
        this.form.countryList = this.countryList
          .filter(
            (item) =>
              !this.form.countryList.some(
                (selected) => selected == item.countryCode
              ) &&
              item.countryCode != 'all' &&
              item.countryCode != 'total'
          )
          .map((item) => item.countryCode)
      }
      if (this.isAdd) {
        this.add()
      } else {
        this.edit()
      }
    },
    async add() {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_live_create +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        this.form
      )
      if (res.code != 0) return this.$message(res.msg)
      this.$message.success('新增成功')
      this.handleClose()
      this.query(true)
    },
    async edit() {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.config_live_update +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        this.form
      )
      if (res.code != 0) return this.$message(res.msg)
      this.$message.success('编辑成功')
      this.handleClose()
      this.query()
    },
    handleClose() {
      this.dialogVisible = false
      this.countryCode = ''
      this.isCountry = false
      this.form = {
        taskLevel: '',
        minPerformance: '',
        levelName: '',
        valid: '',
        levelDesc: '',
        countryList: [],
      }
    },
    handleCurrentChange(val) {
      this.paginationInfo.page = val
      this.query()
    },
  },
}
</script>
<style lang="scss" scoped>
.search {
  display: flex;
  > * {
    margin: 0 5px;
  }
  .el-input {
    width: 200px;
  }
}
.btns {
  display: flex;
  flex-direction: column;
  gap: 4px;
  > * {
    margin: 0 5px;
  }
}

.countryList {
  min-height: 100px;
  width: 90%;
  border: 2px dotted #ccc;
  margin: 10px 0;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  gap: 3px 10px;

  .item {
    position: relative;
    height: 20px;
    padding: 0 10px;
    text-align: center;
    line-height: 20px;
    width: max-content;
    border: 1px solid #000;
    border-radius: 20px;

    .close {
      position: absolute;
      top: -5px;
      font-size: 15px;
      color: blue;
    }
  }
}
</style>
